

// import React, { useEffect, useState, useRef } from "react";
// import {
//     DollarSign, ShoppingBag, Calculator, Star as StarIcon,
//     TrendingUp, TrendingDown, Download, Sparkles, ChefHat
// } from 'lucide-react';
// import axios from "axios";
// import * as XLSX from "xlsx";
// import "./FoodDashboard.css";
// import FoodOffersSection from "./FoodOffersSection";
// import FoodQuickLinksSection from "./FoodQuickLinksSection";

// const Dashboard = () => {
//     const [vendorId, setVendorId] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [data, setData] = useState(null);
//     const [isMobile, setIsMobile] = useState(false);
//     const [hoveredMetric, setHoveredMetric] = useState(null);
//     const mainRef = useRef(null);

//     // Responsive check
//     useEffect(() => {
//         const checkMobile = () => setIsMobile(window.innerWidth < 768);
//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     // Get vendor ID
//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         if (storedVendorId) setVendorId(storedVendorId);
//     }, []);

//     // Fetch data
//     const fetchData = async () => {
//         if (!vendorId) return;
//         setLoading(true);
//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) {
//                 setLoading(false);
//                 return;
//             }
//             const res = await axios.get(
//                 `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setData(res.data);
//             setLoading(false);
//         } catch (err) {
//             console.error("Error fetching report:", err);
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchData();
//     }, [vendorId]);

//     // Export function
//     const handleExport = () => {
//         const totals = {
//             revenue: data?.dailyRevenue || 2119,
//             expenses: 0,
//             orders: data?.dailyOrders || 13,
//             rating: 4.5
//         };
        
//         const exportData = [{
//             Date: new Date().toLocaleDateString('en-IN'),
//             Revenue: `₹${totals.revenue.toLocaleString()}`,
//             Expenses: `₹${totals.expenses.toLocaleString()}`,
//             Orders: totals.orders,
//             Rating: `${totals.rating}/5`,
//             'Net Profit': `₹${(totals.revenue - totals.expenses).toLocaleString()}`
//         }];
        
//         const ws = XLSX.utils.json_to_sheet(exportData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Today's Summary");
//         const currentDate = new Date().toISOString().split('T')[0];
//         XLSX.writeFile(wb, `Today_Summary_${currentDate}.xlsx`);
//     };

//     // ========== RENDER FUNCTIONS ==========

//     const renderLoading = () => (
//         <div style={{
//             height: "100vh",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
//         }}>
//             <div style={{
//                 textAlign: 'center'
//             }}>
//                 <div style={{
//                     width: '50px',
//                     height: '50px',
//                     border: '3px solid rgba(255, 255, 255, 0.3)',
//                     borderTopColor: 'white',
//                     borderRadius: '50%',
//                     animation: 'spin 1s linear infinite',
//                     margin: '0 auto 16px'
//                 }}></div>
//                 <div style={{
//                     fontSize: '16px',
//                     fontWeight: '600',
//                     color: 'white',
//                     opacity: 0.9
//                 }}>
//                     Loading dashboard...
//                 </div>
//             </div>
//         </div>
//     );

//     const renderHeaderSection = () => {
//         // Use API data for daily revenue and orders
//         const totals = {
//             revenue: data?.dailyRevenue || 0,
//             expenses: 0,
//             orders: data?.dailyOrders || 0,
//             rating: 4.5
//         };
        
//         const formatNumber = (num) => {
//             return `₹${num.toLocaleString()}`;
//         };

//         const metrics = [
//             {
//                 label: 'Revenue',
//                 value: formatNumber(totals.revenue || 0),
//                 icon: <DollarSign size={18} />,
//                 trend: '+12.5%',
//                 trendIcon: <TrendingUp size={12} />,
//                 color: '#10B981',
//                 bgColor: 'rgba(16, 185, 129, 0.08)'
//             },
//             // {
//             //     label: 'Expenses',
//             //     value: formatNumber(totals.expenses || 0),
//             //     icon: <Calculator size={18} />,
//             //     trend: '-3.2%',
//             //     trendIcon: <TrendingDown size={12} />,
//             //     color: '#EF4444',
//             //     bgColor: 'rgba(239, 68, 68, 0.08)'
//             // },
//             {
//                 label: 'Orders',
//                 value: totals.orders || '0',
//                 icon: <ShoppingBag size={18} />,
//                 trend: '+24.7%',
//                 trendIcon: <TrendingUp size={12} />,
//                 color: '#F59E0B',
//                 bgColor: 'rgba(245, 158, 11, 0.08)'
//             },
//             {
//                 label: 'Rating',
//                 value: `${totals.rating?.toFixed(1) || '4.5'}/5`,
//                 icon: <StarIcon size={18} />,
//                 trend: '+0.2',
//                 trendIcon: <Sparkles size={12} />,
//                 color: '#3B82F6',
//                 bgColor: 'rgba(59, 130, 246, 0.08)'
//             }
//         ];

//         return (
//             <div style={{
//                 background: '#FFFFFF',
//                 padding: isMobile ? '16px 12px' : '20px 16px',
//                 marginTop: '-20px'
//             }}>
//                 {/* Metrics Grid */}
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//                     gap: '12px',
//                     marginBottom: '16px'
//                 }} className="moblie-view-response">
//                     {metrics.map((metric, index) => (
//                         <div 
//                             key={index}
//                             onMouseEnter={() => setHoveredMetric(index)}
//                             onMouseLeave={() => setHoveredMetric(null)}
//                             style={{
//                                 background: metric.bgColor,
//                                 borderRadius: '14px',
//                                 padding: '16px',
//                                 border: `1px solid ${metric.color}20`,
//                                 boxShadow: hoveredMetric === index 
//                                     ? `0 8px 24px ${metric.color}20`
//                                     : '0 2px 8px rgba(0, 0, 0, 0.04)',
//                                 transform: hoveredMetric === index 
//                                     ? 'translateY(-4px)' 
//                                     : 'translateY(0)',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.2s ease',
//                                 position: 'relative'
//                             }}
//                         >
//                             {/* Content */}
//                             <div style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'flex-start',
//                                 marginBottom: '12px'
//                             }}>
//                                 <div style={{
//                                     background: 'white',
//                                     width: '40px',
//                                     height: '40px',
//                                     borderRadius: '10px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     color: metric.color,
//                                     boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
//                                     border: `1px solid ${metric.color}20`
//                                 }}>
//                                     {metric.icon}
//                                 </div>
                                
//                                 <div style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '3px',
//                                     padding: '4px 8px',
//                                     background: 'rgba(255, 255, 255, 0.9)',
//                                     borderRadius: '12px',
//                                     fontSize: '11px',
//                                     fontWeight: '600',
//                                     color: metric.color,
//                                     border: `1px solid ${metric.color}20`
//                                 }}>
//                                     {metric.trendIcon}
//                                     <span>{metric.trend}</span>
//                                 </div>
//                             </div>
                            
//                             <div style={{
//                                 fontSize: isMobile ? '20px' : '22px',
//                                 fontWeight: '700',
//                                 color: '#1E293B',
//                                 marginBottom: '4px',
//                                 lineHeight: '1'
//                             }}>
//                                 {metric.value}
//                             </div>
                            
//                             <div style={{
//                                 fontSize: '13px',
//                                 fontWeight: '600',
//                                 color: metric.color,
//                                 marginBottom: '6px'
//                             }}>
//                                 {metric.label}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         );
//     };

//     // ========== MAIN RENDER ==========

//     if (loading) {
//         return renderLoading();
//     }

//     return (
//         <div ref={mainRef} style={{
//             height: '100vh',
//             display: 'flex',
//             flexDirection: 'column',
//             fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//             background: '#F8FAFC'
//         }}>
//             {/* Main Container with scroll */}
//             <div style={{
//                 flex: 1,
//                 overflowY: 'auto',
//                 scrollbarWidth: 'none',
//                 msOverflowStyle: 'none'
//             }}>
//                 {/* Header Section */}
//                 {renderHeaderSection()}
                
//                 {/* Offers Section */}
//                 <div style={{
//                     padding: isMobile ? '0 12px 20px' : '0 16px 24px',
//                     background: 'white'
//                 }}>
//                     <FoodOffersSection isMobile={isMobile} />
//                 </div>
                
//                 {/* Quick Links Section */}
//                 <div style={{
//                     padding: isMobile ? '0 12px 20px' : '0 16px 24px',
//                     background: 'white'
//                 }}>
//                     <FoodQuickLinksSection isMobile={isMobile} onExport={handleExport} />
//                 </div>

//                 {/* Footer Note */}
//                 {/* <div style={{
//                     textAlign: 'center',
//                     padding: '16px',
//                     fontSize: '12px',
//                     color: '#94A3B8',
//                     borderTop: '1px solid #E2E8F0',
//                     margin: isMobile ? '0 12px' : '0 16px',
//                     marginBottom: '20px',
//                     background: '#FFFFFF',
//                     borderRadius: '12px'
//                 }}>
//                     <p style={{ margin: '0 0 6px 0' }}>
//                         Last updated: {new Date().toLocaleTimeString('en-IN', { 
//                             hour: '2-digit', 
//                             minute: '2-digit' 
//                         })}
//                     </p>
//                     <div style={{
//                         fontSize: '11px',
//                         color: '#6366F1'
//                     }}>
//                         Dashboard v2.0 • Caterings Pro
//                     </div>
//                 </div> */}
//             </div>

//             {/* CSS Styles */}
//             <style>{`
//                 @keyframes spin {
//                     0% { transform: rotate(0deg); }
//                     100% { transform: rotate(360deg); }
//                 }
                
//                 /* Hide scrollbar for Chrome, Safari and Opera */
//                 ::-webkit-scrollbar {
//                     display: none;
//                 }
                
//                 /* Smooth transitions */
//                 * {
//                     transition: background-color 0.2s ease,
//                                 transform 0.2s ease,
//                                 box-shadow 0.2s ease;
//                 }
                
//                 /* Mobile optimizations */
//                 @media (max-width: 768px) {
//                     * {
//                         -webkit-tap-highlight-color: transparent;
//                     }
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default Dashboard;






import React, { useEffect, useState, useRef } from "react";
import {
    DollarSign, ShoppingBag, Calculator, Star as StarIcon,
    TrendingUp, TrendingDown, Download, Sparkles, ChefHat
} from 'lucide-react';
import axios from "axios";
import * as XLSX from "xlsx";
import "./FoodDashboard.css";
import FoodOffersSection from "./FoodOffersSection";
import FoodQuickLinksSection from "./FoodQuickLinksSection";

const Dashboard = () => {
    const [vendorId, setVendorId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [statsData, setStatsData] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const [hoveredMetric, setHoveredMetric] = useState(null);
    const mainRef = useRef(null);

    // Responsive check
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Get vendor ID
    // Get vendor ID and role
    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        const storedRole = localStorage.getItem("role"); // Get role from localStorage

        if (storedVendorId) setVendorId(storedVendorId);

        // Log for debugging
        console.log("Vendor ID:", storedVendorId);
        console.log("User Role:", storedRole);
    }, []);

    // Function to check if user is ROLE_VENDOR
    const isVendor = () => {
        const role = localStorage.getItem("role");
        return role === "ROLE_VENDOR";
    };
    // Fetch initial data
    const fetchData = async () => {
        if (!vendorId) return;
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                setLoading(false);
                return;
            }
            const res = await axios.get(
                `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setData(res.data);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching report:", err);
            setLoading(false);
        }
    };

    // Fetch statistics data for rating
    const fetchStatsData = async () => {
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            if (!token) return;

            // Get current date
            const toDate = new Date();
            const fromDate = new Date();
            // Set fromDate to 1 year before
            fromDate.setFullYear(toDate.getFullYear() - 1);

            // Format dates as YYYY-MM-DD
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            const fromDateStr = formatDate(fromDate);
            const toDateStr = formatDate(toDate);

            const url = `http://testing.maamaas.com:8080/food/api/orders/vendor/statistics/custom?vendorId=${vendorId}&fromDate=${fromDateStr}&toDate=${toDateStr}`;

            const res = await axios.get(
                url,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setStatsData(res.data);
        } catch (err) {
            console.error("Error fetching stats data:", err);
            // If API fails, use default rating of 4.5
            setStatsData({ averageRating: "4.5" });
        }
    };

    useEffect(() => {
        if (vendorId) {
            // Fetch both data in parallel
            Promise.all([fetchData(), fetchStatsData()])
                .finally(() => setLoading(false));
        }
    }, [vendorId]);

    // Export function
    const handleExport = () => {
        const totals = {
            revenue: data?.dailyRevenue || 0,
            expenses: data?.dailyexpenses || 0,
            orders: data?.dailyOrders || 0,
            rating: data?.averageRating || 0
        };

        const exportData = [{
            Date: new Date().toLocaleDateString('en-IN'),
            Revenue: `₹${totals.revenue.toLocaleString()}`,
            Expenses: `₹${totals.expenses.toLocaleString()}`,
            Orders: totals.orders,
            Rating: `${parseFloat(totals.rating).toFixed(1)}/5`,
            'Net Profit': `₹${(totals.revenue - totals.expenses).toLocaleString()}`
        }];

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Today's Summary");
        const currentDate = new Date().toISOString().split('T')[0];
        XLSX.writeFile(wb, `Today_Summary_${currentDate}.xlsx`);
    };

    // ========== RENDER FUNCTIONS ==========

    const renderLoading = () => (
        <div style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <div style={{
                textAlign: 'center'
            }}>
                <div style={{
                    width: '50px',
                    height: '50px',
                    border: '3px solid rgba(255, 255, 255, 0.3)',
                    borderTopColor: 'white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 16px'
                }}></div>
                <div style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'white',
                    opacity: 0.9
                }}>
                    Loading dashboard...
                </div>
            </div>
        </div>
    );

    const renderHeaderSection = () => {
        // Use API data for daily revenue and orders
        const totals = {
            revenue: data?.dailyRevenue || 0,
            expenses: data?.dailyexpenses || 0,
            orders: data?.dailyOrders || 0,
            rating: statsData?.averageRating || "0"
        };

        // Parse rating to float for display
        const ratingValue = parseFloat(totals.rating) || 0;

        const formatNumber = (num) => {
            return `₹${num.toLocaleString()}`;
        };

        const metrics = [
            {
                label: 'Revenue',
                value: formatNumber(totals.revenue || 0),
                icon: <DollarSign size={18} />,
                trend: '+12.5%',
                trendIcon: <TrendingUp size={12} />,
                color: '#10B981',
                bgColor: 'rgba(16, 185, 129, 0.08)'
            },
            {
                label: 'Orders',
                value: totals.orders || '0',
                icon: <ShoppingBag size={18} />,
                trend: '+24.7%',
                trendIcon: <TrendingUp size={12} />,
                color: '#F59E0B',
                bgColor: 'rgba(245, 158, 11, 0.08)'
            },
            {
                label: 'Rating',
                value: `${ratingValue.toFixed(1)}/5`,
                icon: <StarIcon size={18} />,
                trend: `+${Math.max(0, (ratingValue - 4.3)).toFixed(1)}`,
                trendIcon: ratingValue >= 4.3 ? <TrendingUp size={12} /> : <TrendingDown size={12} />,
                color: ratingValue >= 4 ? '#3B82F6' : ratingValue >= 3 ? '#F59E0B' : '#EF4444',
                bgColor: ratingValue >= 4 ? 'rgba(59, 130, 246, 0.08)' :
                    ratingValue >= 3 ? 'rgba(245, 158, 11, 0.08)' :
                        'rgba(239, 68, 68, 0.08)'
            }
        ];

        return (
            <div style={{
                background: '#FFFFFF',
                padding: isMobile ? '16px 12px' : '20px 16px',
                marginTop: '-20px'
            }}>
                {/* Metrics Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                    gap: '12px',
                    marginBottom: '16px',
                    marginLeft: "30px",
                }} className="moblie-view-response">
                    {metrics.map((metric, index) => (
                        <div
                            key={index}
                            onMouseEnter={() => setHoveredMetric(index)}
                            onMouseLeave={() => setHoveredMetric(null)}
                            style={{
                                background: metric.bgColor,
                                borderRadius: '14px',
                                padding: '16px',
                                border: `1px solid ${metric.color}20`,
                                boxShadow: hoveredMetric === index
                                    ? `0 8px 24px ${metric.color}20`
                                    : '0 2px 8px rgba(0, 0, 0, 0.04)',
                                transform: hoveredMetric === index
                                    ? 'translateY(-4px)'
                                    : 'translateY(0)',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                position: 'relative'
                            }}
                        >
                            {/* Content */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '12px'
                            }}>
                                <div style={{
                                    background: 'white',
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: metric.color,
                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
                                    border: `1px solid ${metric.color}20`
                                }}>
                                    {metric.icon}
                                </div>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '3px',
                                    padding: '4px 8px',
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    borderRadius: '12px',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: metric.color,
                                    border: `1px solid ${metric.color}20`
                                }}>
                                    {metric.trendIcon}
                                    <span>{metric.trend}</span>
                                </div>
                            </div>

                            <div style={{
                                fontSize: isMobile ? '20px' : '22px',
                                fontWeight: '700',
                                color: '#1E293B',
                                marginBottom: '4px',
                                lineHeight: '1'
                            }}>
                                {metric.value}
                            </div>

                            <div style={{
                                fontSize: '13px',
                                fontWeight: '600',
                                color: metric.color,
                                marginBottom: '6px'
                            }}>
                                {metric.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    // ========== MAIN RENDER ==========

    if (loading) {
        return renderLoading();
    }

    return (
        <div ref={mainRef} style={{
            // height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            background: '#ffffffff'
        }}>
            {/* Main Container with scroll */}
            <div style={{
                flex: 1,
                overflowY: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            }}>
                {/* Header Section */}
                {localStorage.getItem("role") === "ROLE_VENDOR" && renderHeaderSection()}

                {/* Offers Section */}
                <div style={{
                    padding: isMobile ? '0 12px 20px' : '0 16px 24px',
                    background: 'white',
                    display: isMobile ? "block" : "none",
                }}>
                    <FoodOffersSection isMobile={isMobile} />
                </div>

                {/* Quick Links Section */}
                <div style={{
                    padding: isMobile ? '0 12px 20px' : '0 16px 24px',
                    background: 'white',
                    // height:"100vh",
                }}>
                    <FoodQuickLinksSection isMobile={isMobile} onExport={handleExport} />
                </div>
            </div>

            {/* CSS Styles */}
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                
                /* Hide scrollbar for Chrome, Safari and Opera */
                ::-webkit-scrollbar {
                    display: none;
                }
                
                /* Smooth transitions */
                * {
                    transition: background-color 0.2s ease,
                                transform 0.2s ease,
                                box-shadow 0.2s ease;
                }
                
                /* Mobile optimizations */
                @media (max-width: 768px) {
                    * {
                        -webkit-tap-highlight-color: transparent;
                    }
                }
            `}</style>
        </div>
    );
};

export default Dashboard;